import { IApiRequest } from '@/adapters/axios/IApiRequest'
import { IRemittanceBase } from '@/adapters/remittanceBase/model/IRemittanceBase'
import { sentbizApi } from '../axios'

export interface GetRemittanceBase extends IApiRequest {
  getInstance (): GetRemittanceBase;
  request (): Promise<Array<IRemittanceBase>>;
}

export class GetRemittanceBase implements GetRemittanceBase {
  private static instance: GetRemittanceBase

  private constructor () {
  }

  public static getInstance (): GetRemittanceBase {
    if (!this.instance) this.instance = new GetRemittanceBase()
    return this.instance
  }

  async request (): Promise<Array<IRemittanceBase>> {
    const requestOption: RequestOption = {
      url: 'remittance/bases',
      method: 'get'
    }
    const response = await sentbizApi.request(requestOption)
    return response.data.list
  }
}
